import { combineReducers } from '@reduxjs/toolkit'

import dashboard from './dashboardSlice'
import tests from './testsSlice'

const reducer = combineReducers({
    dashboard,
    tests,
})

export default reducer
